<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  class="my-charge-navigation print:hidden"
  [appearance]="'default'"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.default"
  [opened]="!isScreenSmall"
>
  <div fuseVerticalNavigationHeader class="my-charge-navigation-header">
    <a
      class="my-charge-brand"
      [routerLink]="['/']"
      aria-label="Ir para a página inicial"
    >
      <img [src]="logo" alt="EZVolt" />
    </a>
  </div>

  <div fuseVerticalNavigationFooter class="my-charge-navigation-footer">
    <ng-container *transloco="let t">
      <span class="my-charge-footer-mark" aria-hidden="true">
        <mat-icon [svgIcon]="'heroicons_solid:bolt'"></mat-icon>
      </span>
      <div class="min-w-0 truncate text-xs font-medium text-slate-500">
        {{ t("common.company_name") }} &copy; {{ currentYear }}.
      </div>
    </ng-container>
  </div>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="my-charge-shell flex w-full min-w-0 flex-auto flex-col">
  <!-- Header -->
  <header class="my-charge-topbar print:hidden">
    <div class="flex min-w-0 items-center gap-3">
      <button
        class="my-charge-menu-button"
        mat-icon-button
        (click)="toggleNavigation('mainNavigation')"
        aria-label="Abrir ou fechar o menu"
      >
        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
      </button>

      <div class="min-w-0">
        <div
          class="truncate text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-400"
        >
          My Charge
        </div>
        <h1 class="truncate text-lg font-semibold leading-tight text-slate-900">
          {{
            pageTitle === "My Charge"
              ? pageTitle
              : (pageTitle | transloco)
          }}
        </h1>
      </div>
    </div>

    <div class="my-charge-topbar-actions">
      <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
      <span class="my-charge-topbar-divider" aria-hidden="true"></span>
      <user></user>
    </div>
  </header>

  <!-- Content -->
  <main class="my-charge-content flex w-full flex-auto flex-col">
    <router-outlet *ngIf="true"></router-outlet>
  </main>
</div>
